import React from 'react';
import ServicePage from '../../components/ServicePage';
import { Map, Globe, Unlock, Ghost, Search, BarChart, RefreshCw, ClipboardList, AlertTriangle, FileText } from 'lucide-react';

export default function AssetMapping() {
  return (
    <ServicePage
      title="资产测绘服务"
      subtitle="全互联网视角 · 7 天梳理暴露面 · 平均发现影子资产 40+"
      description="卓迈资产测绘服务从攻击者视角，在互联网上找到你——不是你以为你暴露的，而是攻击者真正能看到的。7 天内完成全域暴露面梳理，平均发现客户未知影子资产 40 项以上，包括遗忘的测试环境、未备案的子域名、开放在公网的内部服务等，并评估每个暴露点的攻击优先级。"
      icon={<Map size={40} strokeWidth={1.5} />}
      color="#0891b2"
      benefits={[
        '攻击者视角的全互联网资产发现',
        '7 天内完成全域暴露面梳理',
        '平均发现影子资产 40+ 项',
        '每个暴露点评估攻击可利用性',
        '持续订阅模式，新增资产实时发现',
      ]}
      features={[
        {
          icon: <Globe size={24} />,
          title: '子域名与 IP 全量发现',
          desc: '通过被动 DNS 数据、证书透明日志（CT Log）、搜索引擎语法、Shodan/FOFA/Hunter 等主动测绘，完整发现企业所有子域名和 IP 资产，包括遗忘多年的废弃子域。',
          points: ['CT Log 证书域名扫描', 'Shodan/FOFA/Hunter 接入', 'DNS 历史记录分析', '旁站与同 IP 识别'],
        },
        {
          icon: <Unlock size={24} />,
          title: '暴露服务指纹识别',
          desc: '对全量资产进行端口扫描和服务指纹识别，发现暴露在公网的 Redis、MongoDB、Elasticsearch、Kafka 等未授权访问服务，以及 SSH/RDP/VNC 等高危远程访问端口。',
          points: ['全端口服务扫描', '未授权服务自动识别', 'Telnet/FTP 等高危协议', '管理后台暴露检测'],
        },
        {
          icon: <Ghost size={24} />,
          title: '影子资产识别',
          desc: '影子资产是企业安全最大的盲区——IT 部门不知道存在、安全团队没有纳管、但攻击者能找到的那些资产。我们平均每个客户发现 40+ 项影子资产，包括测试环境、废弃系统、员工私搭系统等。',
          points: ['废弃测试环境发现', '员工私搭服务识别', '历史子域名梳理', 'IP 段历史使用追踪'],
        },
        {
          icon: <Search size={24} />,
          title: '敏感信息泄露检测',
          desc: '扫描互联网公开渠道的敏感信息泄露——GitHub/Gitee 代码仓库、搜索引擎缓存、招聘 JD 中的技术细节、社工信息等，识别可被用于定向攻击的敏感数据。',
          points: ['GitHub/Gitee 代码泄露', '搜索引擎缓存扫描', '员工信息公开收集', '邮件账号泄露查询'],
        },
        {
          icon: <BarChart size={24} />,
          title: '攻击面优先级评估',
          desc: '不只堆资产清单——对每个暴露点按「可利用性 × 业务影响」双维度评分，告诉你哪 5 个暴露点最危险、攻击者最可能先从哪里打进来，并给出针对性的收敛建议。',
          points: ['双维度攻击优先级排序', '最高危路径可视化', '收敛建议逐项说明', '攻击者画像分析'],
        },
        {
          icon: <RefreshCw size={24} />,
          title: '持续订阅监控',
          desc: '企业资产每天都在变化，新部署的系统可能立刻成为攻击目标。持续订阅服务实时监控新增资产，24 小时内发现新暴露点并告警，防止「刚上线就被打」的场景。',
          points: ['新增资产 24H 告警', '资产变更对比报告', '新发现漏洞即时通知', '周度暴露面趋势报告'],
        },
      ]}
      process={[
        { icon: <ClipboardList size={24} />, title: '目标确认', desc: '确认企业主域名、IP 段、品牌关键词，制定测绘范围边界' },
        { icon: <Globe size={24} />, title: '被动收集', desc: '通过 CT Log、被动 DNS、公开数据源完成初始资产全量收集' },
        { icon: <Search size={24} />, title: '主动探测', desc: '对资产进行端口扫描、指纹识别、敏感信息检测，深度刻画暴露面' },
        { icon: <AlertTriangle size={24} />, title: '风险研判', desc: '专家对高危暴露点逐一验证，按攻击优先级排序，识别影子资产' },
        { icon: <FileText size={24} />, title: '报告交付', desc: '提交《暴露面评估报告》，包含资产清单、风险优先级、收敛建议' },
      ]}
      nextService={{ name: '安全运营服务', path: '/services/security-ops' }}
    />
  );
}
